<!-- <div *ngIf="hideLoader">
  <div *ngIf="!pdfUrl || pdfUrl==''" class="loader-box">
    <dx-load-indicator class="loader-indicator"></dx-load-indicator>
    <h6 class="loader-msg">Loading...</h6>
  </div>
</div>
<ngx-extended-pdf-viewer [ngClass]="pdfUrl==''?'d-none':''" 
  [src]="pdfUrl"
  [showToolbar]="true"
  [showSidebarButton]="false"
  [showFindButton]="false"
  [showPagingButtons]="false"
  [showEditor]="false"
  [showZoomButtons]="true"
  [showPresentationModeButton]="false"
  [showOpenFileButton]="false"
  [showPrintButton]="true"
  [showDownloadButton]="true"
  [showSecondaryToolbarButton]="true"
  [showRotateButton]="false"
  [showHandToolButton]="false"
  [showScrollingButton]="false"
  [showSpreadButton]="false"
  [showPropertiesButton]="false"
  [filenameForDownload]="fileName"
  [printResolution]="'700'"
  [customToolbar]="customToolbar"
  [sidebarVisible]="false"
></ngx-extended-pdf-viewer>



<ng-template #customToolbar>
  <div id="toolbarViewer">
      <div id="toolbarViewerLeft">
          <pdf-paging-area></pdf-paging-area>
      </div>
      <div id="toolbarViewerRight">
          <pdf-print></pdf-print>
          <pdf-download></pdf-download>
      </div>
      <pdf-zoom-toolbar ></pdf-zoom-toolbar>
  </div>
</ng-template> -->

<div class="container">
  <div class="row">
    <div class="col-md-12 text-center m-3">
      {{resMessage}}
    </div>
  </div>
</div>